import { render, staticRenderFns } from "./formWidget.vue?vue&type=template&id=820842d6"
import script from "./formWidget.vue?vue&type=script&lang=js"
export * from "./formWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports